import { DateTime } from 'luxon'

export function toDateTimes(...dates) {
	return dates.filter(Boolean).map(DateTime.fromISO)
}

export function minDate(...dates) {
	return DateTime.min(...toDateTimes(...dates)).toISO()
}

export function maxDate(...dates) {
	return DateTime.max(...toDateTimes(...dates)).toISO()
}

export function inDateRange(date, { from, to }, compare = 'day') {
	const toComparisonUnit = iso => DateTime.fromISO(iso).startOf(compare)
	const start = toComparisonUnit(from)
	const end = toComparisonUnit(to)
	const target = toComparisonUnit(date)
	return target >= start && target <= end
}

export function rangesOverlap(first, second, compare = 'day') {
	const firstFrom = DateTime.fromISO(first.from)
	const firstTo = DateTime.fromISO(first.to)
	const secondFrom = DateTime.fromISO(second.from)
	const secondTo = DateTime.fromISO(second.to)
	return (
		inDateRange(firstFrom, second, compare) ||
		inDateRange(firstTo, second, compare) ||
		inDateRange(secondFrom, first, compare) ||
		inDateRange(secondTo, first, compare)
	)
}

export function stretch({ from, to }) {
	return {
		from: DateTime.fromISO(from)
			.startOf('day')
			.toISO(),
		to: DateTime.fromISO(to)
			.endOf('day')
			.toISO(),
	}
}
